// OK 23/10/2024

import { Setting } from "../interfaces/setting.interface";
import {  ip } from "../utils/setup";

const SETTING_API = `${ip}/api/Settings`;

// GET

export async function getSettings(): Promise<Setting> {
    const response = await fetch(SETTING_API, {
        credentials: "include" 
    });
  if (response.ok) {
    const body: Setting = await response.json();
    return body;
  } else {
    return response.json();
  }
}

// GET ID

// POST

//PUT

export async function updateSettings(updateSettings: Setting) {
  const { globalError, ...restSetting } = updateSettings;
  const response = await fetch(`${SETTING_API}/1`, {
      method: "PUT",
      credentials: "include" ,
      headers: { "Content-Type": "application/json"  },
    body: JSON.stringify(restSetting),
  });
  if (response.ok) {
    return response.ok;
  } else {
    throw new Error("Erreur lors de l'édition de la carte carburant");
  }
}
